// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3THjW","paramInput":"JobSimulator_paramInput__2i3av","input":"JobSimulator_input__22_j_"};